var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _vm._m(0);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "page-container"
  }, [_c('div', {
    staticClass: "navigation-bar"
  }, [_c('div', {
    staticClass: "navigation-bar-left"
  }), _c('div', {
    staticClass: "navigation-bar-title"
  }, [_vm._v($t("r9rg825", "链接已失效"))]), _c('div', {
    staticClass: "navigation-bar-right"
  })]), _c('div', {
    staticClass: "main-container"
  }, [_c('div', {
    staticClass: "form-content pt-8xl"
  }, [_c('div', {
    staticClass: "flex gap-[20px] bg-[#FFF9EF] border-[#FFBF00] border-solid border-[1px] border-[2px] rounded-md p-[10px]"
  }, [_c('img', {
    staticClass: "w-[20px] h-[24px]",
    attrs: {
      "src": require("@/assets/icon/warning.png"),
      "alt": ""
    }
  }), _c('div', {
    staticClass: "flex flex-col gap-2"
  }, [_c('div', {
    staticClass: "text-[16px] text-left font-500 text-[#8B572A]"
  }, [_vm._v(` ${$t("r9rg825", "链接已失效")} `)])])])])])]);
}];
export { render, staticRenderFns };